import React, { useEffect, useState, useCallback } from 'react'
import { Progress } from 'antd'
import './styles.scss'

export const Player = ({ audio }) => {
  const [percent, setPercent] = useState(0)
  const timeUpdated = useCallback(({ target }) => {
    const { currentTime, duration } = target

    setPercent((currentTime * 100) / duration)
  }, [])

  useEffect(() => {
    if (!audio.current) return

    audio.current.addEventListener('timeupdate', timeUpdated)
  }, [audio])

  return (
    <Progress
      className="audio-player"
      percent={percent}
      showInfo={false}
      strokeColor={{
        '0%': '#108ee9',
        '100%': '#87d068',
      }}
    />
  )
}
